var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppShell',{attrs:{"nav-items":_vm.navItems,"admin-nav-items":_vm.adminNavItems}})}
var staticRenderFns = []

export { render, staticRenderFns }